import { createSelector } from 'reselect'
import * as SelectorUtils from './utils'

import { DefaultState } from '../reducers/DefaultState'
import { DISTRIBUTION, MEDIA_COMPANY, SOV_DISTRIBUTION, SOV_STREAMING, STREAMING } from '../constants/sov'

const getSOVCategory = (state, props) => {
  let category = null
  if (props.shortcut && props.shortcut.target) {
    category = props.shortcut.target === SOV_STREAMING ? STREAMING : props.shortcut.target === SOV_DISTRIBUTION ? DISTRIBUTION : MEDIA_COMPANY
  } else {
    category = props.match.params.category
  }
  return category
}

const getSOVState = (state) => {
  return (state || {}).sov || null
}

const getSelectedCategory = createSelector(
  [getSOVState],
  (state) => {
    return (state || {}).selectedCategory || null
  }
)

const getSelectedMetricDate = createSelector(
  [getSOVState],
  (state) => {
    return (state || {}).selectedMetricDate || null
  }
)

const getSOVDetails = createSelector(
  [getSOVState, getSelectedCategory],
  (sovState, category) => {
    return sovState ? sovState.byCategory[category] : null
  }
)

const getContentRankByScore = createSelector(
  [getSOVDetails],
  (state) => {
    return (state || {}).contentRankByScore || null
  }
)

const getSOVNetworksDetailsState = createSelector(
  [getSOVDetails],
  (state) => {
    return (state || {}).networks || DefaultState
  }
)

const getSOVContentRankDetailsState = createSelector(
  [getSOVDetails, getSelectedMetricDate],
  (state, metricDate) => {
    return (state || {})[metricDate] || DefaultState
  }
)

const getSOVContentRankByScoreDetailsState = createSelector(
  [getContentRankByScore, getSelectedMetricDate],
  (state, metricDate) => {
    return (state || {})[metricDate] || DefaultState
  }
)

const makeSOVCategorySelector = () => {
  return createSelector(
    [getSOVCategory],
    category => {
      return category
    }
  )
}

const makeSOVNetworksDetailsSelector = () => {
  return createSelector(
    [getSOVNetworksDetailsState],
    (details) => {
      if (details) {
        return {
          isFetching: SelectorUtils.isFetching(details),
          error: details.error,
          details: details.details
        }
      }
    }
  )
}

const makeSOVContentRankDetailsSelector = () => {
  return createSelector(
    [getSOVContentRankDetailsState],
    (details) => {
      if (details) {
        return {
          isFetching: SelectorUtils.isFetching(details),
          error: details.error,
          details: details.details
        }
      }
    }
  )
}

const makeSOVContentRankByScoreDetailsSelector = () => {
  return createSelector(
    [getSOVContentRankByScoreDetailsState],
    (details) => {
      if (details) {
        return {
          isFetching: SelectorUtils.isFetching(details),
          error: details.error,
          details: details.details
        }
      }
    }
  )
}

export {
  makeSOVNetworksDetailsSelector,
  makeSOVContentRankDetailsSelector,
  makeSOVContentRankByScoreDetailsSelector,
  makeSOVCategorySelector
}
